import { render, staticRenderFns } from "./DonatorReport.vue?vue&type=template&id=62b23a01&"
import script from "./DonatorReport.vue?vue&type=script&lang=js&"
export * from "./DonatorReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DonatorReport.vue"
export default component.exports